function test() {
    const images = document.getElementsByClassName('c-fv__main');
    const logo = document.getElementsByClassName('c-media__logo')[0];
    const button = document.getElementsByClassName('p-nav__button')[0];
    const cp = document.getElementsByClassName('p-cp__wrap')[0];
    const fv = document.getElementsByClassName('c-fv__wrap')[0];

    if (fv) {
        // InView(image);
        window.addEventListener('scroll', () => {
            let y = window.pageYOffset;
            let height = {
                pc: fv.clientHeight / 3,
                sp: fv.clientHeight - 400,
            };
            if (y > height[Check()]) {
                InView(images, logo, fv);
            } else {
                View(images, logo, fv);
            }
        })
    } else {
        const option = {
            sp: {
                fill: 'both',
                duration: 800,
            },
            pc: {
                fill: 'both',
                duration: 2000,
            }
        }
        button.animate({
            backgroundColor: '#535353',
        }, option['sp']);
        logo.animate({
            backgroundColor: '#535353',
        }, option['sp'])
    }

    const Check = () => {
        let width = window.innerWidth;
        if (width < 1024) {
            return 'sp';
        } else {
            return 'pc';
        }
    }

    // 画像表示
    const View = (images, logo, fv) => {
        const option = {
            sp: {
                fill: 'both',
                duration: 800,
            },
            pc: {
                fill: 'both',
                duration: 2000,
            }
        }
        const style = {
            sp: {
                opacity: 1,
            },
            pc: {
                opacity: 1,
                filter: `brightness(1) blur(0px)`
            }
        }
        button.animate({
            backgroundColor: '#ffffff',
        }, option[Check()])
        logo.animate({
            backgroundColor: '#ffffff',
        }, option[Check()])
        if (fv) {
            fv.animate(style[Check()], option[Check()]);
        }
    }

    // 画像非表示
    const InView = (images, logo, fv) => {
        const option = {
            sp: {
                fill: 'both',
                duration: 800,
                rangeStart: "cover 0%",
                rangeEnd: "cover 100%",
            },
            pc: {
                fill: 'both',
                duration: 4000,
                rangeStart: "cover 0%",
                rangeEnd: "cover 100%",
            }
        }
        const style = {
            sp: {
                opacity: 0,
            },
            pc: {
                opacity: 0,
                filter: `brightness(3) blur(8px)`
            }
        }
        button.animate({
            backgroundColor: '#535353',
        }, option[Check()])
        logo.animate({
            backgroundColor: '#535353',
        }, option[Check()])
        fv.animate(style[Check()], option[Check()]);
    }
}
test();

